import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/sharp-regular-svg-icons";
import type { MouseEvent } from "react";

type Values = "yes" | "no" | "partial";

const stateMap: { [key in Values]: Values } = {
    yes: "no",
    partial: "no",
    no: "yes",
};

interface CustomCheckboxProps {
    checked: Values;
    onClick: (value: Values, e: MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    size?: "small" | "normal";
}

export const CustomCheckbox = ({
    size = "normal",
    ...props
}: CustomCheckboxProps) => (
    <button
        className={`
            rounded border-2 ${size === "small" ? "h-3 w-3" : "h-4 w-4"}
            flex flex-shrink-0 items-center justify-center text-white
            ${
                props.disabled
                    ? "bg-ae-gray-100 border-ae-gray-250"
                    : props.checked === "yes"
                      ? "bg-ae-blue-550 border-ae-blue-550"
                      : "border-ae-gray-250"
            }
        `}
        onClick={(e) => {
            if (!props.disabled) {
                props.onClick(stateMap[props.checked], e);
            }
        }}
        type="button"
    >
        {!props.disabled && (
            <>
                {props.checked === "yes" && (
                    <FontAwesomeIcon
                        icon={faCheck}
                        className={size === "small" ? "h-2 w-2" : "h-3 w-3"}
                    />
                )}
                {props.checked === "partial" && (
                    <div
                        className={`bg-ae-blue-550 ${size === "small" ? "w-1.5 h-1.5" : "w-2 h-2"}`}
                    />
                )}
            </>
        )}
    </button>
);
